import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { ApiService } from './Services/api/api.service';
import { register } from 'swiper/element/bundle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, Subscription, tap, throwError } from 'rxjs';
import { AuthService } from './Services/auth/auth.service';
import { StateService } from './Services/state/state.service';
import { Router } from '@angular/router';


register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [
    IonApp,
    IonRouterOutlet,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
  ],
})
export class AppComponent implements OnInit {
  subs: Subscription[] = [];

  constructor(
    private apiService: ApiService,
    private platform: Platform,
    private bridgePayService: AuthService,
    private translate: TranslateService,
    private router:Router,
    private stateService: StateService // private featureFlagService: FeatureFlagService,
  ) {
    this.translate.setDefaultLang('en');
    this.translate.addLangs(['es', 'en']);
  }

  ngOnInit() {
    if (this.stateService.isLoggedIn()) {
    this.router.navigate(['/home'], { replaceUrl: true });
    } else {
    this.router.navigate(['/login'], { replaceUrl: true });
    const lang = localStorage.getItem('lang') || 'en';
    this.translate.use(lang);

    // Check if user is logged in before loading BridgePay config
    const user = this.stateService.getUserInfo();
    if (user) {
      try {
        this.bridgePayService.loadBridgePayConfig();
      } catch (error) {
        console.error('Failed to load BridgePay config:', error);
      }
    }
    this.initializeBranding();
    } 
  }

  initializeBranding() {
    this.apiService
      .initializeBrandingLabels()
      .pipe(
        tap((response) => this.applyBranding(response.settings)),
        catchError((error) => {
          console.error('Failed to initialize branding:', error);
          return throwError(() => error);
        })
      )
      .subscribe();
  }

  applyBranding(branding: any) {
    // Brand Colors
    if (branding.primaryBrandColor) {
      document.documentElement.style.setProperty(
        '--primary-brand-color',
        branding.primaryBrandColor
      );

      // Auto-calculate text color on primary based on contrast
      const textOnPrimary = this.getContrastTextColor(
        branding.primaryBrandColor
      );
      document.documentElement.style.setProperty(
        '--text-on-primary',
        textOnPrimary
      );

      // Update link color to match primary
      document.documentElement.style.setProperty(
        '--text-link-color',
        branding.primaryBrandColor
      );

      // Update focus outline color
      document.documentElement.style.setProperty(
        '--focus-outline-color',
        branding.primaryBrandColor
      );
    }

    if (branding['primaryBrandColor-Opacity40']) {
      document.documentElement.style.setProperty(
        '--primary-brand-color-opacity40percent',
        branding['primaryBrandColor-Opacity40']
      );
    }

    if (branding.secondaryBrandColor) {
      document.documentElement.style.setProperty(
        '--secondary-brand-color',
        branding.secondaryBrandColor
      );

      // Auto-calculate text color on secondary based on contrast
      const textOnSecondary = this.getContrastTextColor(
        branding.secondaryBrandColor
      );
      document.documentElement.style.setProperty(
        '--text-on-secondary',
        textOnSecondary
      );
    }

    // Brand Assets
    if (branding.logoUrl) {
      document.documentElement.style.setProperty(
        '--logo-url',
        `url('${branding.logoUrl}')`
      );
    }

    if (branding.loginLogoUrl) {
      document.documentElement.style.setProperty(
        '--login-logo-url',
        `url('${branding.loginLogoUrl}')`
      );
    }

    if (branding.loginImg) {
      console.log(`login image: ${branding.loginImg}`)
      document.documentElement.style.setProperty(
        '--login-url',
        `url('${branding.loginImg}')`
      );
    }

    if (branding.headerDesktopImg) {
      document.documentElement.style.setProperty(
        '--header-desktop-img',
        `url('${branding.headerDesktopImg}')`
      );
    }

    if (branding.headerMobileImg) {
      document.documentElement.style.setProperty(
        '--header-mobile-img',
        `url('${branding.headerMobileImg}')`
      );
    }

    if (branding.sidebarBgImg) {
      document.documentElement.style.setProperty(
        '--sidebar-bg-img',
        `url('${branding.sidebarBgImg}')`
      );
    }
  }

  /**
   * Calculate whether white or black text provides better contrast
   * on a given background color (for WCAG AA compliance)
   */
  private getContrastTextColor(hexColor: string): string {
    // Remove # if present
    const hex = hexColor.replace('#', '');

    // Convert to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate relative luminance (WCAG formula)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return white for dark backgrounds, black for light backgrounds
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }
}
